(function () {
  "use strict";

  // Lighthouse scrolls during audits — do not treat scroll as "user intent"
  // or third parties load mid-lab and inflate unused-JS / TBT.
  var TIMEOUT_MS = 8000;
  var PDP_GTM_TIMEOUT_MS = 20000;
  var CART_SELECTORS =
    '.cart-link, #CartButton, [href="/cart"], a[href$="/cart"], .js-drawer-open-cart';

  var scriptPromises = {};
  var stylePromises = {};
  var started = {
    rebuy: false,
    accessibe: false,
    gtm: false,
    addShoppers: false,
  };

  function isProductPage() {
    return (window.OcuThirdPartyConfig || {}).pageKind === "product";
  }

  function isCartPage() {
    return (window.OcuThirdPartyConfig || {}).pageKind === "cart";
  }

  /** PDP: use productTimeout (null = interaction only). Other pages: 8s idle. */
  function deferOptions(productTimeoutMs) {
    if (isProductPage()) {
      return { timeoutMs: productTimeoutMs };
    }
    return { timeoutMs: TIMEOUT_MS };
  }

  function loadScript(src, options) {
    if (scriptPromises[src]) return scriptPromises[src];

    scriptPromises[src] = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === "true") {
          resolve();
          return;
        }
        existing.addEventListener("load", function () {
          resolve();
        });
        existing.addEventListener("error", reject);
        return;
      }

      var s = document.createElement("script");
      s.src = src;
      s.async = true;
      if (options && options.type) s.type = options.type;
      if (options && options.id) s.id = options.id;
      s.onload = function () {
        s.dataset.loaded = "true";
        resolve();
      };
      s.onerror = reject;
      (document.head || document.body).appendChild(s);
    });

    return scriptPromises[src];
  }

  function loadStylesheet(href) {
    if (stylePromises[href]) return stylePromises[href];

    stylePromises[href] = new Promise(function (resolve, reject) {
      var existing = document.querySelector('link[rel="stylesheet"][href="' + href + '"]');
      if (existing) {
        resolve();
        return;
      }

      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      (document.head || document.documentElement).appendChild(link);
    });

    return stylePromises[href];
  }

  function onIdleOrInteract(callback, options) {
    var timeoutMs = TIMEOUT_MS;
    if (options && Object.prototype.hasOwnProperty.call(options, "timeoutMs")) {
      timeoutMs = options.timeoutMs;
    }
    var done = false;
    var timeoutId = null;

    function run() {
      if (done) return;
      done = true;
      cleanup();
      callback();
    }

    function cleanup() {
      window.removeEventListener("pointerdown", run, true);
      window.removeEventListener("keydown", run, true);
      window.removeEventListener("touchstart", run, true);
      document.removeEventListener("click", onCartClick, true);
      if (timeoutId != null) clearTimeout(timeoutId);
    }

    function onCartClick(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest(CART_SELECTORS)) run();
    }

    window.addEventListener("pointerdown", run, {
      capture: true,
      passive: true,
      once: true,
    });
    window.addEventListener("keydown", run, { capture: true, once: true });
    window.addEventListener("touchstart", run, {
      capture: true,
      passive: true,
      once: true,
    });
    document.addEventListener("click", onCartClick, true);

    if (timeoutMs != null) {
      timeoutId = setTimeout(run, timeoutMs);
    }
  }

  function startRebuyScripts(shopDomain) {
    if (!shopDomain) return Promise.resolve();

    var experiments =
      "https://cdn.rebuyengine.com/onsite/js/experiments.js";
    var rebuy =
      "https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=" +
      encodeURIComponent(shopDomain);

    return loadScript(experiments)
      .then(function () {
        return loadScript(rebuy);
      })
      .catch(function () {
        started.rebuy = false;
      });
  }

  function loadRebuy(shopDomain) {
    if (started.rebuy || !shopDomain) return;
    started.rebuy = true;

    // Cart page: Rebuy Smart Cart redirects /cart → flyout. Load immediately
    // so the page does not sit broken until the 8s idle deferral fires.
    if (isCartPage()) {
      startRebuyScripts(shopDomain);
      return;
    }

    onIdleOrInteract(function () {
      startRebuyScripts(shopDomain);
    }, deferOptions(null));
  }

  function usesRebuySmartCart() {
    var cartType =
      (window.theme && theme.settings && theme.settings.cartType) || "";
    return cartType !== "drawer";
  }

  function revealRebuySmartCart(smartCart) {
    var el = document.querySelector(".rebuy-cart");
    // A too-early show() can leave visible=true without .is-visible.
    if (
      smartCart.visible &&
      el &&
      !el.classList.contains("is-visible")
    ) {
      smartCart.hide();
      setTimeout(function () {
        smartCart.show();
      }, 50);
    } else {
      smartCart.show();
    }
  }

  // cart_type is "page" so theme.CartDrawer never inits — it normally owns
  // #CartBubble / .cart-link__qty visibility. Keep those in sync ourselves.
  function updateThemeCartBubble(count) {
    var n = parseInt(count, 10);
    if (isNaN(n) || n < 0) n = 0;

    var bubble = document.querySelector("#CartBubble");
    if (bubble) {
      bubble.classList.toggle("cart-link__bubble--visible", n > 0);
    }

    document.querySelectorAll(".cart-link__qty").forEach(function (el) {
      el.textContent = String(n);
      el.classList.toggle("cart-link__qty--visible", n > 0);
    });
  }

  function refreshThemeCartBubble() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateThemeCartBubble(cart && cart.item_count);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function bindThemeCartBubbleSync() {
    if (!usesRebuySmartCart()) return;

    document.addEventListener("rebuy:cart.change", function (event) {
      var cartMod = event && event.detail && event.detail.cart;
      var shopifyCart = cartMod && cartMod.cart ? cartMod.cart : null;
      if (shopifyCart && typeof shopifyCart.item_count !== "undefined") {
        updateThemeCartBubble(shopifyCart.item_count);
      } else {
        refreshThemeCartBubble();
      }
    });
  }

  // Theme AjaxProduct posts /cart/add.js before deferred Rebuy is listening.
  // Rebuy can finish init from a stale empty /cart.js — resync before show.
  function syncRebuyCartFromShopify(done) {
    var Cart = window.Rebuy && Rebuy.Cart;
    var smartCart = window.Rebuy && Rebuy.SmartCart;
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      if (typeof done === "function") done();
    }

    function apply(rebuyCart) {
      if (finished) return;
      try {
        var shopifyCart =
          rebuyCart && rebuyCart.cart ? rebuyCart.cart : rebuyCart;
        if (shopifyCart && smartCart && typeof smartCart.setCart === "function") {
          smartCart.setCart(shopifyCart);
        }
        if (shopifyCart && typeof shopifyCart.item_count !== "undefined") {
          updateThemeCartBubble(shopifyCart.item_count);
        }
        if (smartCart && typeof smartCart.updateCartCount === "function") {
          smartCart.updateCartCount();
        }
      } catch (e) {
        // Still open the drawer even if sync helpers throw.
      }
      finish();
    }

    if (!Cart || typeof Cart.fetchShopifyCart !== "function") {
      finish();
      return;
    }

    try {
      var result = Cart.fetchShopifyCart(apply);
      if (result && typeof result.then === "function") {
        result.then(function (cart) {
          apply(cart);
        }).catch(finish);
      }
    } catch (e) {
      finish();
      return;
    }

    // Never block the drawer open if Rebuy's fetch hangs.
    setTimeout(finish, 2000);
  }

  function showRebuySmartCart(attemptsLeft, options) {
    var shouldSync = options && options.sync;
    var smartCart = window.Rebuy && Rebuy.SmartCart;
    if (
      smartCart &&
      smartCart.status === "ready" &&
      typeof smartCart.show === "function"
    ) {
      if (shouldSync) {
        syncRebuyCartFromShopify(function () {
          revealRebuySmartCart(smartCart);
        });
      } else {
        revealRebuySmartCart(smartCart);
      }
      return;
    }
    if (attemptsLeft > 0) {
      setTimeout(function () {
        showRebuySmartCart(attemptsLeft - 1, options);
      }, 100);
    }
  }

  // cart_type is "page" — Rebuy Smart Cart is the drawer. If Rebuy is still
  // deferred, the first cart-icon click loads it but never opens it.
  function bindSmartCartOpener() {
    if (!usesRebuySmartCart()) return;

    document.addEventListener(
      "click",
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest(CART_SELECTORS)) return;
        if (!usesRebuySmartCart()) return;

        event.preventDefault();
        event.stopPropagation();

        var shopDomain = (window.OcuThirdPartyConfig || {}).rebuyShop;
        if (shopDomain) {
          if (!started.rebuy) {
            loadRebuy(shopDomain);
          }
          // Force script fetch now (deduped) so we do not wait on idle alone.
          started.rebuy = true;
          startRebuyScripts(shopDomain);
        }

        showRebuySmartCart(50);
      },
      true
    );
  }

  function loadAccessibe(initOptions) {
    if (started.accessibe) return;
    started.accessibe = true;

    onIdleOrInteract(function () {
      loadScript("https://acsbapp.com/apps/app/dist/js/app.js")
        .then(function () {
          if (window.acsbJS && typeof window.acsbJS.init === "function") {
            window.acsbJS.init(initOptions || {});
          }
        })
        .catch(function () {
          started.accessibe = false;
        });
    }, deferOptions(null));
  }

  function loadGtm(gtmConfig) {
    if (started.gtm || !gtmConfig || !gtmConfig.gtmId) return;
    started.gtm = true;

    onIdleOrInteract(function () {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js",
        });

        if (gtmConfig.elevarConfig) {
          var cfg = document.createElement("script");
          cfg.id = "elevar-gtm-suite-config";
          cfg.type = "application/json";
          cfg.textContent = JSON.stringify(gtmConfig.elevarConfig);
          (document.head || document.documentElement).appendChild(cfg);
        }

        var suiteSrc =
          (gtmConfig.elevarConfig && gtmConfig.elevarConfig.gtm_suite_script) ||
          gtmConfig.suiteSrc;
        var gtmSrc =
          "https://www.googletagmanager.com/gtm.js?id=" +
          encodeURIComponent(gtmConfig.gtmId);

        var chain = Promise.resolve();
        if (suiteSrc) {
          chain = chain.then(function () {
            return loadScript(suiteSrc);
          });
        }
        chain
          .then(function () {
            return loadScript(gtmSrc);
          })
          .catch(function () {
            started.gtm = false;
          });
      } catch (e) {
        started.gtm = false;
      }
    }, deferOptions(PDP_GTM_TIMEOUT_MS));
  }

  function loadAddShoppers(addShoppersConfig) {
    if (started.addShoppers || !addShoppersConfig || !addShoppersConfig.src) return;
    started.addShoppers = true;

    onIdleOrInteract(function () {
      window.AddShoppersWidgetOptions = addShoppersConfig.options || {
        loadCss: false,
        pushResponse: false,
      };
      loadScript(addShoppersConfig.src, { id: "AddShoppers" }).catch(function () {
        started.addShoppers = false;
      });
    }, deferOptions(null));
  }

  function bootFromConfig() {
    var config = window.OcuThirdPartyConfig || {};
    if (config.rebuyShop) {
      loadRebuy(config.rebuyShop);
    }
    if (config.accessibe) {
      loadAccessibe(config.accessibe);
    }
    if (config.gtm) {
      loadGtm(config.gtm);
    }
    if (config.addShoppers) {
      loadAddShoppers(config.addShoppers);
    }
  }

  window.OcuThirdParty = {
    loadScript: loadScript,
    loadStylesheet: loadStylesheet,
    onIdleOrInteract: onIdleOrInteract,
    loadRebuy: loadRebuy,
    loadAccessibe: loadAccessibe,
    loadGtm: loadGtm,
    loadAddShoppers: loadAddShoppers,
  };

  function openSmartCartAfterAjaxAdd() {
    if (!usesRebuySmartCart()) return;

    // Show bubble immediately — CartDrawer is not mounted to do this.
    updateThemeCartBubble(1);
    refreshThemeCartBubble();

    var shopDomain = (window.OcuThirdPartyConfig || {}).rebuyShop;
    if (shopDomain) {
      started.rebuy = true;
      startRebuyScripts(shopDomain);
    }
    // More attempts than icon-open: Rebuy often starts loading on this same click.
    showRebuySmartCart(80, { sync: true });
  }

  bootFromConfig();
  bindSmartCartOpener();
  bindThemeCartBubbleSync();
  document.addEventListener("ajaxProduct:added", openSmartCartAfterAjaxAdd);
})();
